import { UseDisclosureProps, HTMLChakraProps, Text, Box, Container, Flex, Image, Heading } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { queryThinLectureWithTagAndEvent } from '@/fetchers/thinLectures';
import { useResource } from '@/lib/datx-jsonapi-react';

export const LectureNoContent: FC<UseDisclosureProps & HTMLChakraProps<'div'>> = () => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: lecture } = useResource(queryThinLectureWithTagAndEvent(lectureId));
  const { t } = useTranslation();

  return (
    <Container>
      <Flex position="relative">
        <Box position="absolute" top="0" bottom="0" left="0" right="0" zIndex={0} bgColor="black" opacity="0.75" />
        <Image
          ignoreFallback={true}
          src={lecture?.largePosterUrl}
          mx="auto"
          w="full"
          minH={['300px', null, null, '550px']}
        />
        <Box position="absolute" w="full" h="full">
          <Flex justifyContent="center" direction="column" h="full" maxW="592px" p={4} mx="auto">
            <Heading as="h4" color="white" size="lg" mt={[2, null, 4]} mb={[4, null, 8]} textAlign="center">
              {t('noContent.title')}
            </Heading>
            <Text as="p" textAlign="center" color="white" fontSize={['md', null, 'xl']} lineHeight={['5', null, '7']}>
              {t('noContent.description')}
            </Text>
          </Flex>
        </Box>
      </Flex>
    </Container>
  );
};
